<template>
  <div id="app">
    <vue-snotify></vue-snotify>
    <div class="logo-wrapper">
      <img src="./assets/logo.png" alt="Whiteside times logo" class="logo">
    </div>

    <AppHeader></AppHeader>
    <div class="wrapper">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
    <AppFooter></AppFooter>
  </div>

</template>

<script>
  import AppHeader from '@/components/Header'
  import AppFooter from '@/components/Footer'

  export default {
    name: 'AppLayout',
    components: {
      AppHeader,
      AppFooter
    }
  }
</script>

<style lang="scss">
  #app {
    position: relative;

    display: flex;
    flex-direction: column;

    .logo-wrapper {
      width: 100%;
      position: fixed;
      padding-top: 40px;
      padding-left: 40px;
      @include media_tablet {
        display: flex;
        justify-content: center;
        padding-left: 0;
      }
      .logo {
        width: auto;
        height: 150px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/app.layout.vue